// extracted by mini-css-extract-plugin
export var gif = "_in-0";